import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  title: string;
  module: string;
  model: string;
  description: ReactNode;
  children: ReactNode;
}

export function AgentPageShell({ title, module, model, description, children }: Props) {
  return (
    <div className="space-y-6 max-w-5xl">
      <div>
        <Link to="/" className="text-taupe text-sm hover:text-ink">
          ← Retour au tableau de bord
        </Link>
      </div>
      <header>
        <div className="flex items-baseline gap-3 flex-wrap">
          <h2 className="font-serif text-3xl font-bold">{title}</h2>
          <span className="text-xs uppercase tracking-wider text-taupe">{module}</span>
          <span className="text-xs font-mono text-taupe">{model}</span>
        </div>
        <p className="text-taupe mt-2 max-w-3xl">{description}</p>
      </header>
      {children}
    </div>
  );
}

export function FormCard({ title, children, action }: { title: string; children: ReactNode; action?: ReactNode }) {
  return (
    <div className="card space-y-4">
      <div className="flex items-center justify-between">
        <div className="text-xs uppercase tracking-wider text-taupe">{title}</div>
        {action}
      </div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

export function Field({
  label,
  children,
  hint,
}: {
  label: string;
  children: ReactNode;
  hint?: string;
}) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-ink">{label}</span>
      {hint && <span className="block text-xs text-taupe mb-1">{hint}</span>}
      <div className="mt-1">{children}</div>
    </label>
  );
}

export const inputCls =
  'w-full border border-border rounded px-3 py-2 text-sm font-sans focus:outline-none focus:ring-2 focus:ring-gold/40 focus:border-gold';
